"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationBar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var _1 = require(".");
var material_1 = require("@mui/material");
var svgs_1 = require("../assets/svgs");
var utils_1 = require("../utils");
var NotificationBar = function (_a) {
    var status = _a.status, note = _a.note, title = _a.title;
    return ((0, jsx_runtime_1.jsxs)(_1.Card, __assign({ sx: { position: 'relative' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                    position: 'absolute',
                    width: '0.8rem',
                    height: '100%',
                    backgroundColor: (0, utils_1.statusColors)(status),
                    borderTopLeftRadius: '1.0rem',
                    borderBottomLeftRadius: '1.0rem',
                } }), (0, jsx_runtime_1.jsx)(_1.CardContent, __assign({ sx: { paddingLeft: '4rem', paddingY: '2.8rem' } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: 'row', alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.AlertBubble, {}), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: { marginLeft: '20px' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: "h2", variant: "bodyXLarge", sx: {
                                        marginBottom: '0.4rem',
                                        color: 'primary.600',
                                        fontWeight: 'medium',
                                    } }, { children: title })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: "h2", variant: "bodyMedium", sx: {
                                        color: 'primary.400',
                                    } }, { children: note }))] }))] })) }))] })));
};
exports.NotificationBar = NotificationBar;
